import { useAtomValue } from "jotai";
import { Drawer } from "@zapier/product-nav";
import { sideBarSelectedAtom, SUMMARY } from "@zapier/canvas-state";
import {
  ModifyPromptSidebar,
  ModifyPromptSidebarHeader,
  isModifyPromptOpenAtom,
} from "@zapier/streaming";

import capitalizeFirstLetter from "../../utils/capitalizeFirstLetter";
import { SummaryPanel } from "../SummaryPanel";
import DevTools from "../DevTools/DevTools";
import { ProjectSidebar } from "../ProjectSidebar";
import { GraphData } from "../GraphData";
import { DisplayPreferencesPanel } from "../DisplayPreferencesPanel";
import { CanvasComposer } from "../CanvasComposer";

type Props = {
  handleOnClose: () => void;
};

export default function SidebarDrawer({ handleOnClose }: Props) {
  const SIDEBAR_CONTENT = {
    project: {
      title: "Project",
      component: <ProjectSidebar />,
    },
    [SUMMARY]: {
      title: capitalizeFirstLetter(SUMMARY),
      component: <SummaryPanel />,
    },
    displayPreferences: {
      title: "Display Preferences",
      component: <DisplayPreferencesPanel />,
    },
    devTools: {
      title: "🔒 DevTools - staff only (⌘D)",
      component: <DevTools />,
    },
    graphData: {
      title: "Graph Data - staff only",
      component: <GraphData />,
    },
    modifyPrompt: {
      title: <ModifyPromptSidebarHeader />,
      component: <ModifyPromptSidebar />,
    },
    composer: {
      title: "Canvas Composer",
      component: <CanvasComposer onClose={handleOnClose} />,
    },
    composer2: {
      title: "Zapier Composer 2",
      component: <CanvasComposer onClose={handleOnClose} />,
    },
  };

  const sideBarSelected = useAtomValue(sideBarSelectedAtom);
  const isModifyPromptOpen = useAtomValue(isModifyPromptOpenAtom);

  const regularSelectedSidebar = sideBarSelected
    ? SIDEBAR_CONTENT[sideBarSelected]
    : {
        title: "",
        component: null,
      };

  const selectedSidebar = isModifyPromptOpen
    ? SIDEBAR_CONTENT["modifyPrompt"]
    : regularSelectedSidebar;

  return (
    <Drawer
      onClose={handleOnClose}
      title={selectedSidebar.title as string}
      isOpen={Boolean(sideBarSelected) || isModifyPromptOpen}
      isFixed={false}
      hasSidePadding={
        sideBarSelected !== SUMMARY &&
        sideBarSelected !== "displayPreferences" &&
        !isModifyPromptOpen
      }
    >
      <div>{selectedSidebar.component}</div>
    </Drawer>
  );
}
